export default __webpack_public_path__ + "static/chevron-bbd6aa36b23fdcfb1fbe9550c1011ba0.svg";